export enum FilterScope {
  DocumentsAndImages = "Documents + Images",
  Documents = "Documents",
}
